const CACHE_DURATION = Number(import.meta.env.CACHE_DURATION || 10 * 60 * 1000); // default to 10 minutes
import { getCacheFromDB, setCacheToDB } from '../utils/cache';

export async function cachedFetch(url: string, options?: RequestInit): Promise<Response> {
  const cacheKey = 'cfetch_' + url + JSON.stringify(options || {});
  const now = Date.now();

  // Try to get from IndexedDB
  const cachedData = await getCacheFromDB(cacheKey);
  if (cachedData) {
    const age = now - cachedData.timestamp;
    if (age < CACHE_DURATION) {
      // Rebuild Response from cached data
      return new Response(cachedData.body, {
        status: cachedData.status,
        headers: cachedData.headers,
      });
    }
  }

  // Fetch from network and cache
  const response = await fetch(url, options);
  const cloned = response.clone();
  const body = await cloned.text(); // important: get body as text to store

  const headersObj: Record<string, string> = {};
  cloned.headers.forEach((value, key) => {
    headersObj[key] = value;
  });

  const cachedResponse = {
    timestamp: now,
    body,
    status: cloned.status,
    headers: headersObj,
  };

  // Cache the response in IndexedDB
  await setCacheToDB(cacheKey, cachedResponse);

  return new Response(body, {
    status: cloned.status,
    headers: headersObj,
  });
}
